"use client";

import React, { useState } from "react";
import swal from "sweetalert";
import { Mail } from "lucide-react";
import { useParams } from "next/navigation";
import { useTranslations } from "next-intl";

export default function Contact() {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        message: "",
    });

    const { locale } = useParams();
    const t = useTranslations("Contact");

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const subject = "Website contact form";
        const body = [
            `Name: ${formData.name}`,
            `Email: ${formData.email}`,
            "",
            "Message:",
            formData.message,
        ].join("\n");

        window.location.href = `mailto:info@pomzaexport.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
        swal("E-mail hazır", "Mesajınız e-posta uygulamanızda açıldı. Göndermek için e-postayı onaylayın.", "success");
    };

    return (
        <main className="bg-[#151a38]" id="contact">
            <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
                <div className="my-10">
                    <div className="mb-6 max-w-3xl text-center sm:text-center md:mx-auto md:mb-12">
                        <p className="text-base font-semibold uppercase tracking-wide text-blue-600 dark:text-blue-200"></p>
                        <h1 className="font-heading mb-4 font-bold tracking-tight text-white dark:text-white text-3xl sm:text-5xl capitalize">
                            {t("contactUs")}
                        </h1>
                    </div>
                </div>
                <div className="flex items-stretch justify-center">
                    <div className="grid md:grid-cols-2">
                        <div className="h-full pr-6">
                            <ul className="mb-6 md:mb-0">
                                <li className="flex">
                                    <div className="flex h-10 w-10 items-center justify-center rounded bg-blue-900 text-gray-50">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="h-6 w-6"
                                        >
                                            <path d="M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"></path>
                                            <path d="M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0z"></path>
                                        </svg>
                                    </div>
                                    <div className="ml-4 mb-4">
                                        <h2 className="mb-2 text-lg font-medium leading-6 text-white dark:text-white capitalize">
                                            {t("contactAdresses")}
                                        </h2>
                                        <p className="text-white dark:text-slate-400">
                                            <strong className="uppercase">
                                                {t("sartMadenIsletmesi")}
                                            </strong>
                                            <br />
                                            <span>
                                                Sart Mah. Pomza Sk. No: 40,
                                                Salihli/MANİSA
                                            </span>
                                            <br />
                                            <span className="capitalize">
                                                {t("telephone")}
                                            </span>{" "}
                                            <span>: +90 236 724 20 21</span>
                                            <br />
                                            <span className="capitalize">
                                                {t("fax")}
                                            </span>{" "}
                                            <span>: +90 236 724 30 51</span>{" "}
                                            <br />
                                            <br />
                                            <strong className="uppercase">
                                                {t("eilePomex")}
                                            </strong>
                                            <br />
                                            <span>
                                                Yeniköy Mah. Menderes - Orhanlı
                                                Yolu Sk. No : 179/26
                                                Menderes/İZMİR
                                            </span>
                                            <br />
                                            <span className="capitalize">
                                                {t("telephone")}
                                            </span>{" "}
                                            <span>: +90 232 360 17 77</span>
                                            <br />
                                            <span className="capitalize">
                                                {t("fax")}
                                            </span>{" "}
                                            <span>: +90 232 360 16 16</span>
                                            <br />
                                            <br />
                                            <strong className="uppercase">
                                                {t("menderesMadenIsletmesi")}
                                            </strong>
                                            <br />
                                            <span>
                                                Küner Mah. 7801 Sk. No:94
                                                Menderes/İZMİR
                                            </span>
                                            <br />
                                            <span className="capitalize">
                                                {t("telephone")}
                                            </span>{" "}
                                            <span>: +90 232 782 14 46</span>
                                            <br />
                                            <span className="capitalize">
                                                {t("fax")}
                                            </span>{" "}
                                            <span>: +90 232 782 15 98</span>
                                            <br />
                                            <br />
                                            <strong className="uppercase">
                                                {t("etiperPerlitIsletmesi")}
                                            </strong>
                                            <br />
                                            <span>
                                                Yeniköy Mah. Menderes - Orhanlı
                                                Yolu Sk. No : 179/22
                                                Menderes/İZMİR
                                            </span>
                                            <br />
                                            <span className="capitalize">
                                                {t("telephone")}
                                            </span>{" "}
                                            <span>: +90 232 782 67 24</span>
                                            <br />
                                            <span className="capitalize">
                                                {t("fax")}
                                            </span>{" "}
                                            <span>: +90 232 782 67 25</span>
                                            <br />
                                            <br />
                                            <strong className="uppercase">
                                                {t("ankaraOffice")}
                                            </strong>
                                            <br />
                                            <span>
                                                Çukurca Birlik Mah. 447 Sk. No:
                                                3/5 Çankaya/ANKARA
                                            </span>
                                            <br />
                                            <span className="capitalize">
                                                {t("telephone")}
                                            </span>{" "}
                                            <span>: +90 312 495 64 90</span>
                                            <br />
                                            <span className="capitalize">
                                                {t("fax")}
                                            </span>{" "}
                                            <span>: +90 312 495 64 93</span>
                                        </p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div
                            className="card h-fit max-w-6xl p-5 md:p-12 md:pt-1"
                            id="form"
                        >
                            <div className="flex">
                                <Mail color="white" />
                                <span className="ml-3 text-white text-bold text-lg">
                                    info@pomzaexport.com
                                </span>
                            </div>
                            <h2 className="my-4 text-2xl font-bold text-white capitalize">
                                {t("contactUs")}
                            </h2>
                            <form id="contactForm" onSubmit={handleSubmit}>
                                <div className="mb-6">
                                    <div className="mx-0 mb-1 sm:mb-4">
                                        <div className="mx-0 mb-1 sm:mb-4">
                                            <label
                                                htmlFor="name"
                                                className="pb-1 text-xs uppercase tracking-wider"
                                            ></label>
                                            <input
                                                type="text"
                                                id="name"
                                                name="name"
                                                required
                                                maxLength={120}
                                                aria-label={t("nameSurname")}
                                                autoComplete="given-name"
                                                placeholder={t("nameSurname")}
                                                className="capitalize mb-2 w-full rounded-md border border-gray-400 py-2 pl-2 pr-4 shadow-md dark:text-gray-300 sm:mb-0"
                                                value={formData.name}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="mx-0 mb-1 sm:mb-4">
                                            <label
                                                htmlFor="email"
                                                className="pb-1 text-xs uppercase tracking-wider"
                                            ></label>
                                            <input
                                                type="email"
                                                id="email"
                                                name="email"
                                                required
                                                maxLength={254}
                                                aria-label={t("email")}
                                                autoComplete="email"
                                                autoCapitalize="none"
                                                autoCorrect="off"
                                                spellCheck={false}
                                                placeholder={t("email")}
                                                className="normal-case mb-2 w-full rounded-md border border-gray-400 py-2 pl-2 pr-4 shadow-md dark:text-gray-300 sm:mb-0"
                                                value={formData.email}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="mx-0 mb-1 sm:mb-4">
                                        <label
                                            htmlFor="textarea"
                                            className="pb-1 text-xs uppercase tracking-wider"
                                        ></label>
                                        <textarea
                                            id="textarea"
                                            name="message"
                                                required
                                                maxLength={5000}
                                                aria-label={t("yourMessage")}
                                            cols="30"
                                            rows="5"
                                            placeholder={t("yourMessage")}
                                            className="capitalize mb-2 w-full rounded-md border border-gray-400 py-2 pl-2 pr-4 shadow-md dark:text-gray-300 sm:mb-0"
                                            value={formData.message}
                                            onChange={handleChange}
                                        ></textarea>
                                    </div>
                                </div>
                                <div className="text-center">
                                    <button
                                        type="submit"
                                        style={{ textTransform: "capitalize" }}
                                        className="w-full bg-white text-[#151a38] px-6 py-3 font-xl rounded-md sm:mb-0 flex items-center justify-center"
                                    >
                                        <span className="capitalize p-0 m-0 flex items-center">
                                            {t("send")}
                                        </span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
}
